import maxBy from "lodash/maxBy";

export function getComparativeDiscountPercentageByInitialUnitPrice(products, selectedProductId) {
	const mostExpensiveProduct = maxBy(products, (product) => product.initialUnitPrice);
	const selectedProduct = products.find((product) => product.productId === selectedProductId);
	const differenceInPrice = mostExpensiveProduct.initialUnitPrice
		- selectedProduct.initialUnitPrice;
	const percentageDifference = (differenceInPrice / mostExpensiveProduct.initialUnitPrice) * 100;
	const roundedDiscount = Math.round(percentageDifference);
	return roundedDiscount ? `${roundedDiscount}%` : null;
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/getComparativeDiscount.js